export default __webpack_public_path__ + "static/media/Cane2Sugar_01.f445b67e.png";